<script>
  /* 期間限定キャンペーンの告知。未ログインのときだけ出す。
     表示するかどうかの判断は campaign.svelte.js に集約している。 */
  import { CAMPAIGN, campaignActive, campaignLeftLabel } from "../lib/campaign.svelte.js";
  import { auth } from "../lib/authState.svelte.js";

  /** ボタンを内側に置くか（呼び出し側にボタンがあるときは false） */
  let { showButton = false, onjoin = () => {} } = $props();

  const show = $derived(campaignActive() && auth.syncEnabled && !auth.user);
</script>

{#if show}
  <div class="camp">
    <div class="camp-tape">期間限定キャンペーン</div>
    <div class="camp-body">
      <span class="camp-em">{CAMPAIGN.em}</span>
      <div class="camp-text">
        <div class="camp-title">{CAMPAIGN.title}</div>
        <div class="camp-note">{CAMPAIGN.note}</div>
      </div>
    </div>
    <div class="camp-foot">
      <span class="camp-chip">{CAMPAIGN.endLabel}</span>
      <span class="camp-left">{campaignLeftLabel()}</span>
      {#if showButton}
        <span class="spacer"></span>
        <button class="btn camp-btn" onclick={onjoin}>今すぐ登録する</button>
      {/if}
    </div>
  </div>
{/if}
